
import { BLOG_POST_IMAGE_MAP, CATEGORY_TO_SEARCH_TERM, CUSTOM_IMAGES } from './constants';
import { getUnsplashImageById, searchUnsplashImage } from './unsplashApi';
import { getFallbackImage } from './fallback';

/**
 * Get an image for a blog post with priority system:
 * 1. Custom uploaded images (highest priority)
 * 2. Pre-mapped high-quality Unsplash images 
 * 3. Category-based Unsplash search
 * 4. High-quality fallback images
 */
export const getBlogPostImage = async (slug: string, category: string): Promise<string> => {
  try {
    console.log(`Getting image for blog post: ${slug}, category: ${category}`);
    
    // Check for custom uploaded images first (highest priority)
    if (CUSTOM_IMAGES[slug]) {
      console.log(`Using custom image for ${slug}: ${CUSTOM_IMAGES[slug]}`);
      return CUSTOM_IMAGES[slug];
    }
    
    // Try pre-mapped high-quality images (second priority)
    if (BLOG_POST_IMAGE_MAP[slug]) {
      try {
        console.log(`Using pre-mapped image for ${slug}: ${BLOG_POST_IMAGE_MAP[slug]}`);
        const image = await getUnsplashImageById(BLOG_POST_IMAGE_MAP[slug]);
        console.log(`Successfully loaded pre-mapped image: ${image}`);
        return image;
      } catch (error) {
        console.warn(`Failed to load pre-mapped image for ${slug}, trying fallback`);
      }
    }
    
    // Try category-based search if online (third priority)
    if (navigator.onLine) {
      try {
        const searchTerm = CATEGORY_TO_SEARCH_TERM[category] || category;
        console.log(`Searching Unsplash for: ${searchTerm}`);
        const image = await searchUnsplashImage(searchTerm);
        console.log(`Found search result: ${image}`);
        return image;
      } catch (error) {
        console.warn(`Unsplash search failed for ${category}, using fallback`);
      }
    } else {
      console.info('Offline mode - using fallback images');
    }

    // Use high-quality fallback as last resort
    const fallbackImage = getFallbackImage(category);
    console.log(`Using fallback image: ${fallbackImage}`);
    return fallbackImage;
    
  } catch (error) {
    console.error('Error getting blog post image:', error);
    return getFallbackImage(category);
  }
};
